<template>
	<!-- 帳戶設定》安全中心 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>安全中心</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 安全中心 -->
		<div class="deal_content_box">
			<div class="deal_content_title">保護狀態</div>
			<div class="deal_content div_hight_end">
				<div class="lest_hist">經營資料</div>
				<el-row>
					<el-col :span="9" class="col_div">
						<el-col :span:="8">
							<img src="../../../../assets/img/user/03security_center.png" alt="" width="130px">
						</el-col>
						<el-col :span:="8">
							<div class="center_div">
								<div class="dost_h1">實名認證</div>
								<div class="dost_h2">已認證</div>
							</div>
						</el-col>
						<el-col :span:="8">
							<div class="center_div_end">保護中</div>
						</el-col>
					</el-col>
					<el-col :span="9" class="col_div">
						<el-col :span:="8">
							<img src="../../../../assets/img/user/04security_center.png" alt="" width="130px">
						</el-col>
						<el-col :span:="8">
							<div class="center_div">
								<div class="dost_h1">銀行認證</div>
								<div class="dost_h2">未認證</div>
							</div>
						</el-col>
						<el-col :span:="8">
							<div class="center_div_endoff">未保護</div>
						</el-col>
					</el-col>
				</el-row>
				<div class=" div_hight_end">
					<div class="lest_hist">驗證保護</div>
					<el-row>
						<el-col :span="9" class="col_div">
							<el-col :span:="8">
								<img src="../../../../assets/img/user/06security_center.png" alt="" width="130px">
							</el-col>
							<el-col :span:="8">
								<div class="center_div">
									<div class="dost_h1">交易密碼</div>
									<div class="dost_h2">已設定</div>
								</div>
							</el-col>
							<el-col :span:="8">
								<div class="center_div_end"></div>
							</el-col>
						</el-col>
						<el-col :span="9" class="col_div">
							<el-col :span:="8">
								<img src="../../../../assets/img/user/05security_center.png" alt="" width="130px">
							</el-col>
							<el-col :span:="8">
								<div class="center_div">
									<div class="dost_h1">google認證</div>
									<div class="dost_h2">已認證</div>
								</div>
							</el-col>
							<el-col :span:="8">
								<div class="center_div_endoff">未保護</div>
							</el-col>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9" class="col_div">
							<el-col :span:="8">
								<img src="../../../../assets/img/user/02security_center.png" alt="" width="130px">
							</el-col>
							<el-col :span:="8">
								<div class="center_div">
									<div class="dost_h1">google認證</div>
									<div class="dost_h2">已認證</div>
								</div>
							</el-col>
							<el-col :span:="8">
								<div class="center_div_end">保護中</div>
							</el-col>
						</el-col>
					</el-row>
				</div>
				<div class=" div_hight_end">
					<div class="lest_hist">操作日誌</div>
					<el-row>
						<el-col :span="9" class="col_div">
							<el-col :span:="8">
								<img src="../../../../assets/img/user/01security_center.png" alt="" width="130px">
							</el-col>
							<el-col :span:="8">
								<div class="center_div">
									<div class="dost_h1">執行記錄</div>
									<div class="dost_h2">已設定</div>
								</div>
							</el-col>
							<el-col :span:="8">
								<div class="center_div_end">保護中</div>
							</el-col>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>

	</div>



</template>

<script>
	export default {
		data() {
			return {
				ruleForm: {
					email: ''
				},
				formMail: {
					fileFront: '',
					trader: '',
					name: '',
					full_name: '',
				},
				formBank: {
					type: '1',
					name: '',
					affiliation: '',
					account: '',
					numberVal: ''
				},
				lilist: 1,



			};
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			tabfun(index) {
				this.lilist = index
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表頭 */
	.deal_index_box {
		margin: 30px;
		font-size: 15px;
		color: black;
	}

	.lstl_bock {
		height: 1px;
	}

	.p_list {
		color: #777777;
		padding-left: 30px;
		padding-top: 20px;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		/* min-height: 100px; */
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}



	.deal_content_title span {
		display: block;
		height: 35px;
		width: 30px;
		float: right;
		padding-left: 10px;
		padding-top: 5px;
		background: url("../../../../assets/img/user/service_list.png") center no-repeat;
	}



	.div_bottom div {
		margin-bottom: 25px;
		color: #777777;
	}




	/* 按鈕 */
	/deep/.input_high .el-input .el-input__inner {
		height: 27px;
		border: 1px solid #cccccc;
	}

	/deep/.input_high .el-input i {
		line-height: 30px;
	}

	.input_high {
		padding-left: 10px;
	}

	.check_right label {
		margin-right: 5px;
	}

	.list_tile_sed {
		background-color: #fff4cc;
		line-height: 40px;
		margin: 30px 100px 25px 30px;

	}

	.colro-red {
		color: #ff4a05;
		font-size: 20px;
	}

	.list_span,
	.color_list_e {
		color: #e73262;
	}

	.right_col {
		float: left;
	}

	.right_col_left {
		color: #4d80e7;
		padding-left: 15px
	}

	.list_span_end {
		color: #e73262;
		padding-left: 15px;
	}

	.div_bntoon {
		color: #e73262;
		border-bottom: 1px solid #e73262;
	}

	.button_cetent {
		padding-bottom: 5px;
		padding-left: 10px;
	}

	.button_cetent button {
		background-color: #ff771a;
		border: #ff771a;
		height: 20px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 3px;
		padding-right: 3px;
		width: 90px;
		font-size: 11px;
	}

	.button_stend {
		padding-bottom: 25px;
		margin-left: 10px;
	}

	.button_stend_stes button {
		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 75px;
		font-weight: 700;
	}

	.button_stend button {

		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 45px;
		font-weight: 700;
	}

	.painde_top {
		padding: 50px;
	}

	.bottom_onew {
		color: #e73262;
		border-color: #e73262;
	}

	.bottom_two {
		background: #e73262;
		color: #FFFFFF;

	}

	.icon_phigt {
		padding: 5px;
		margin-bottom: 100px;
	}

	.paind_bottm_end {
		padding-bottom: 10px;
	}

	.input_high i {
		font-size: 30px;
	}

	.list_span_str {
		font-weight: 700;
		color: #e73262;
		margin-left: -80px;
		font-size: 15px;
	}

	.flex_display {
		display: flex;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.phone_box .progress_box {
		position: relative;
		line-height: 18px;
		margin: 0 auto;
		margin-top: 40px;
		margin-bottom: 40px;
		overflow: hidden;
		color: #777777;
	}

	.progress_step {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #e73262;
	}

	.progress_step>div {
		box-sizing: border-box;
		line-height: 18px;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.progress_step>div>span {
		margin: 0 6px;
	}

	.lest_hist {
		border-left: 2px;
		padding-left: 10px;
	}

	.button_box {
		display: flex;
		justify-content: center;
		width: 600px;
		margin: 0 auto;
		margin-top: 40px;
		margin-bottom: 50px;
	}

	.button_box .btns_sty {
		margin: 0 30px;
	}

	.list_high_end {
		padding-bottom: 30px;
	}

	/deep/.el-form-item__label {
		color: #000000;
	}

	.bank_content_tow {
		display: none;
	}

	.lest_hist {
		font-weight: 700;
		border-left: 10px solid #e73262;
		font-size: 15px;
	}

	.col_div {
		height: 110px;
		border: 1px solid #b2b2b2;
		margin: 25px;
		display: flex;
	}
	.deal_content .col_div:hover  {
	  border: #e73262 2px solid;
	}
	.deal_content .col_div:first-child {
	  border-left: 2;
	}

	.center_div {
		padding-top: 20px;
		height: 50px;
		padding-left: 10px;
		padding-right: 10px;
		color: #777777;

	}

	.dost_h1 {
		font-size: 21px;
	}

	.dost_h2 {
		padding-top: 10px;
		font-size: 15px;
	}

	.center_div_end {
		padding-left: 10px;
		font-size: 31px;
		font-weight: 700;
		color: #E73262;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.center_div_endoff {
		padding-left: 10px;
		font-size: 31px;
		font-weight: 700;
		color: #000000;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}
	
</style>
